export const wrapEpic =
  (epic) =>
  (...args) =>
    epic(...args).catch((error, source) => {
      setTimeout(() => {
        throw error;
      }, 0);
      return source;
    });



// WEBPACK FOOTER //
// ./src/lib/utils/epic.js